'use client';

import {useTranslation} from 'react-i18next';

import {Button, type OlympusButtonVariant} from '../primitives';
import {usePageRegisterInterestContext} from './page-register-interest-context';
import {openRegisterInterest, type RegisterInterestOpenOptions} from './register-interest-controller';

interface RegisterInterestCtaProps {
  fullWidth?: boolean;
  variant?: OlympusButtonVariant;
  onClick?: () => void;
  options?: RegisterInterestOpenOptions;
}

export function RegisterInterestCta({fullWidth = false, variant, onClick, options}: RegisterInterestCtaProps) {
  const {t} = useTranslation();
  const pageContext = usePageRegisterInterestContext();
  const style = fullWidth ? {width: '100%'} : undefined;
  return (
    <Button
      variant={variant}
      onClick={() => {
        onClick?.();
        openRegisterInterest(options ?? pageContext);
      }}
      sx={style}
    >
      {t('register_interest')}
    </Button>
  );
}

RegisterInterestCta.displayName = 'RegisterInterestCta';
